// extracted by mini-css-extract-plugin
export var card = "_aw-1";
export var container = "_aw-0";